import { Ref } from '@vue/composition-api';
import { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
import store from '@/renderer/store';

export interface InviteMemberChangedParams {
  changed?: CoFile.TeamOrMemberItem[];
  deleted?: CoFile.TeamOrMemberItem[];
  added?: CoFile.TeamOrMemberItem[];
}

export default function handler(groupId: Ref<number>) {
  // 带有外部成员
  const methods = {
    handlerError(error: MsgError) {
      const msg = [i18n_t('成员设置失败')];
      msg.push(formatError(error.code, true));
      tips.error(msg.filter(s => s).join(','));
    },
    async addMembers(members?: CoFile.TeamOrMemberItem[]) {
      if (!members || members.length === 0) return true;
      const params = {
        groupId: groupId.value,
        users: members.map(user => ({
          userId: user.userId as number,
          role: 'user',
          authRoleId: user.roleId as number,
          orgId: user.orgId as number,
        })),
      };
      try {
        await smh.userAPI.addCollaborationSpaceMembers(params);
        return true;
      } catch (error: MsgError) {
        methods.handlerError(error);
        return false;
      }
    },
    async updateMembers(members?: CoFile.TeamOrMemberItem[]) {
      if (!members || members.length === 0) return true;
      const params = {
        groupId: groupId.value,
        users: members.map(user => ({
          userId: user.userId as number,
          role: 'user',
          authRoleId: user.roleId as number,
          orgId: user.orgId as number,
        })),
      };
      try {
        await smh.userAPI.updateCollaborationSpaceMembers(params);
        return true;
      } catch (error: MsgError) {
        methods.handlerError(error);
        return false;
      }
    },
    async deleteMembers(members?: CoFile.TeamOrMemberItem[]) {
      if (!members || members.length === 0) return true;
      const params = {
        groupId: groupId.value,
        users: members.map(user => ({
          userId: user.userId as number,
          orgId: user.orgId as number,
        })),
      };
      try {
        await smh.userAPI.deleteCollaborationSpaceMember(params);
        return true;
      } catch (error: MsgError) {
        methods.handlerError(error);
        return false;
      }
    },
    async onChangeInviteMembers(params: InviteMemberChangedParams) {
      const { added, changed, deleted } = params;
      const [isAdded, isUpdate, isDeleted] = await Promise.all([
        methods.addMembers(added),
        methods.updateMembers(changed),
        methods.deleteMembers(deleted),
      ]);
      if (isAdded && isUpdate && isDeleted) {
        tips.success(i18n_t('成员设置成功'));
        return true;
      }
      return false;
    },
    /** 退出当前群组 */
    async quit(members?: CoFile.TeamOrMemberItem[]) {
      if (!members || members.length === 0) return true;
      const params = {
        groupId: groupId.value,
        users: members.map(user => ({
          userId: user.userId as number,
          ...(user.orgId !== store.getters.orgId && {
            orgId: user.orgId,
          }),
        })),
      };
      try {
        await smh.userAPI.exitCollaborationSpace(params);
        return true;
      } catch (error: MsgError) {
        methods.handlerError(error);
        return false;
      }
    },
  };
  return {
    methods,
  };
}
